import React, { useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { useControls } from 'leva';
import { useRecoilValue } from 'recoil';
import { annotationState } from 'features/three-view/state/threeAtoms';
import { gridPresetForAnnotation } from '../utils/gridPreset';

export const GridControls: React.FC = () => {
  const [
    { size, pitch, colorCenterLine, colorGrid, XY, YZ, ZX },
    set,
  ] = useControls('Axes Grid', () => ({
    size: {
      value: 5000,
      min: 1000,
      max: 10000,
      step: 10,
    },
    pitch: {
      value: 1000,
      min: 100,
      max: 10000,
      step: 10,
    },
    colorCenterLine: '#444444',
    colorGrid: '#888888',
    XY: true,
    YZ: false,
    ZX: false,
  }), { collapsed: true });

  // annotation プリセット押下時に対応する grid plane に自動連動。
  // プリセット外の title (Custom など) では何もしない（Leva の手動状態を維持）。
  const annotation = useRecoilValue(annotationState);
  useEffect(() => {
    const preset = gridPresetForAnnotation(annotation.title);
    if (preset) set(preset);
  }, [annotation.title, annotation.idx, set]);

  const gridHelpers = useMemo(() => {
    const range = 2 * size;
    const helpers: THREE.GridHelper[] = [];

    if (XY) {
      const helper = new THREE.GridHelper(
        0.001 * range,
        range / pitch,
        new THREE.Color(colorCenterLine),
        new THREE.Color(colorGrid)
      );
      helper.rotation.set(Math.PI / 2, 0, 0);
      helpers.push(helper);
    }

    if (YZ) {
      const helper = new THREE.GridHelper(
        0.001 * range,
        range / pitch,
        new THREE.Color(colorCenterLine),
        new THREE.Color(colorGrid)
      );
      helper.rotation.set(0, 0, Math.PI / 2);
      helpers.push(helper);
    }

    if (ZX) {
      helpers.push(
        new THREE.GridHelper(
          0.001 * range,
          range / pitch,
          new THREE.Color(colorCenterLine),
          new THREE.Color(colorGrid)
        )
      );
    }

    return helpers;
  }, [size, pitch, colorCenterLine, colorGrid, XY, YZ, ZX]);

  return (
    <>
      {gridHelpers.map((helper) => (
        <primitive key={helper.uuid} object={helper} />
      ))}
    </>
  );
};
